import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function GelatoPage() {

    const heroData = [
        {
          title: "Gelato",
          content: "Gelato is a traditional Italian frozen dessert, known for its rich flavor and creamy texture. Made with milk, sugar, and natural flavorings, it contains less air and fat than regular ice cream, resulting in a denser, more intense taste.",
          image: images.GelatoHeroImage, 
        },
      ];

    const productData = [
      {
        name: "Vanilla",
        content: "",
        price: 0,
        image: [
          images.Gelato1,
        ]
      },
      {
        name: "Chocolate",
        content: "",
        price: 0,
        image: [
          images.Gelato2,
        ]
      },
      {
        name: "Mango",
        content: "",
        price: 0,
        image: [
          images.Gelato3,
        ]
      },
      {
        name: "Cookies with Ripple",
        content: "",
        price: 0,
        image: [
          images.Gelato4,
        ]
      },
      {
        name: "Salted Butter Caramel",
        content: "",
        price: 0,
        image: [
          images.Gelato5,
        ]
      },
      {
        name: "Pistachio",
        content: "",
        price: 0,
        image: [
          images.Gelato6,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Cookies with Ripple",
        image1: [
          images.Gelato4,
        ],
        content1: "",
        name2: "Salted Butter Caramel",
        image2: [
          images.Gelato5,
        ],
        content2: ""
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
